import { ErrorTypes } from '../types/ErrorTypes';
import { logMediaPlayerErrorMetric } from './logMediaPlayerErrorMetric';
export const logMediaError = ({
  mediaElement,
  requestedRecordingUrlUpdate = false,
  setErrorStatus,
  source
}) => {
  let errorType = ErrorTypes.UNKNOWN;
  if (mediaElement && mediaElement.networkState === 3) {
    // media not found = NETWORK_NO_SOURCE
    errorType = ErrorTypes.NETWORK_NO_SOURCE;
  } else {
    const errorCode = mediaElement && mediaElement.error && mediaElement.error.code;
    switch (errorCode) {
      case 1:
        {
          // fetching process aborted by user =MEDIA_ERR_ABORTED
          errorType = ErrorTypes.MEDIA_ERR_ABORTED;
          break;
        }
      case 2:
        {
          // error occurred when downloading = MEDIA_ERR_NETWORK
          errorType = ErrorTypes.MEDIA_ERR_NETWORK;
          break;
        }
      case 3:
        {
          // error occurred when decoding = MEDIA_ERR_DECODE
          errorType = ErrorTypes.MEDIA_ERR_DECODE;
          break;
        }
      case 4:
        {
          // audio/video not supported = MEDIA_ERR_SRC_NOT_SUPPORTED
          errorType = ErrorTypes.MEDIA_ERR_SRC_NOT_SUPPORTED;
          break;
        }
      default:
        {
          // unknown error = UNKNOWN
          errorType = ErrorTypes.UNKNOWN;
        }
    }
  }
  setErrorStatus(errorType);
  logMediaPlayerErrorMetric({
    errorType,
    source,
    requestedRecordingUrlUpdate
  });
};